import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Secured from 'secured/components';
import { GrowlMessages } from 'messages/containers';

import { toggleMenuCollapsed } from 'secured/actions';

import { getMenu } from 'secured/selectors';
import { getCompany, getSubcompany, getUser, getPermissions } from 'auth/selectors';
import { getVisibleSubcompanies } from 'subcompanies/selectors';

class SecuredLayoutContainer extends PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
    company: PropTypes.object,
    permissions: PropTypes.object,
    subcompany: PropTypes.object,
    subcompanies: PropTypes.array,
    user: PropTypes.object,
  };

  render = () => (
    <Secured.Layout
      company={this.props.company}
      subcompany={this.props.subcompany}
      subcompanies={this.props.subcompanies}
      permissions={this.props.permissions}
      user={this.props.user}
      menu={this.props.menu}
      toggleMenu={this.props.toggleMenuCollapsed}
    >
      <GrowlMessages />
      {this.props.children}
    </Secured.Layout>
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  subcompanies: getVisibleSubcompanies(state),
  permissions: getPermissions(state),
  user: getUser(state),
  menu: getMenu(state),
});

export default connect(mapStateToProps, { toggleMenuCollapsed })(SecuredLayoutContainer);



// WEBPACK FOOTER //
// src/modules/secured/containers/SecuredLayoutContainer.js